/**
 * mushuModule
 *
 * Description 目数功能权限分配
 * Author:Qian.qianchen 2018-10-16
 */
'use strict';
angular.module('manageCfg.roleManageMent.permissionAssignment')
    .controller("operateCenterIndexCtrl", ["$scope", "$q", "$timeout", "$state", "$modal", "$compile", "$element", "trsHttpService", "modalDialog", "permissionAssignmentService",
        function($scope, $q, $timeout, $state, $modal, $compile, $element, trsHttpService, modalDialog, permissionAssignmentService) {
            //声明将要保存权限的数组对象开始
            var selecetedChanls = {};
            //声明将要保存权限的数组对象结束
            initData();
            $scope.channelTreeOptions = {
                nodeChildren: "CHILDREN",
                injectClasses: {
                    ul: "a1",
                    li: "manage-main-rightDiv-leftDiv-treeLi",
                    liSelected: "a7",
                    iExpanded: "a3", //"manage-main-rightDiv-leftDiv-treeIcon",
                    iCollapsed: "a4", //"manage-main-rightDiv-leftDiv-treeIcon",
                    iLeaf: "a5",
                    label: "a6",
                    labelSelected: "a8"
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN !== "true";
                },
                dirSelectable: true,
                allowDeselect: false
            };
            /**
             * [isAuthorized description]判断是否已赋权，渲染左侧树节点
             * @return boolean [description]
             */
            $scope.isAuthorized = function(node) {
                var flag = false;
                if (angular.isDefined(node.RIGHTINDEX)) {
                    var rightIndexs = node.RIGHTINDEX.split(",");
                    for (var i = 0; i < rightIndexs.length; i++) {
                        if (node.RIGHTVALUE[parseInt(rightIndexs[i].replace(/\"/g, "")) - 1] === "1") {
                            flag = true;
                        }
                    }
                }
                return flag;
            };
            $scope.cTshowSelected = function(sel) {
                permissionAssignmentService.initGroupRight(sel, $scope.roleData.ROLEID).then(function(data) {
                    sel.RIGHTID = data;
                    delete $scope.rightClassify;
                    $scope.authorSelectedNode = sel;
                    if (!angular.isArray($scope.authorSelectedNode.RIGHTVALUE)) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.authorSelectedNode.RIGHTVALUE.split("");
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf("1") > -1 ? true : false;
                    }
                    //将要推送的保存权限对象开始
                    var tempId = $scope.authorSelectedNode.OBJID;
                    var tempObj = {
                        "ID": parseInt($scope.authorSelectedNode.RIGHTID),
                        "OPRTYPE": 203,
                        "OPRID": parseInt($scope.roleData.ROLEID),
                        "OBJTYPE": parseInt($scope.authorSelectedNode.OBJTYPE),
                        "OBJID": parseInt($scope.authorSelectedNode.OBJID),
                        "NEWVALUE": $scope.authorSelectedNode.RIGHTVALUE
                    };

                    selecetedChanls[tempId] = tempObj;
                    //将要推送的保存权限对象结束
                    // queryRightClassify(sel.CLASSIFY);
                    queryRightClassify($scope.classify);
                });
            };
            //处理节点名称，用于应对不同模块类型节点名称显示
            $scope.getNodeDesc = function(node) {
                return node.UNITNAME || node.DEPTNAME || node.NAME;
            };
            //保存权限开始
            $scope.save = function() {
                var i = 0,
                    postRights = [];
                for (var key in selecetedChanls) {
                    postRights.push(angular.copy(selecetedChanls[key]));
                    postRights[i].NEWVALUE = angular.isArray(postRights[i].NEWVALUE) ? postRights[i].NEWVALUE.join("") : postRights[i].NEWVALUE;
                    i++;
                }
                var postRightsString = JSON.stringify(postRights);
                var params = {
                    "serviceid": "mlf_extrole",
                    "methodname": "saveRight",
                    "RoleId": $scope.roleData.ROLEID,
                    "rights": postRightsString
                };
                if (postRights.length === 0) {
                    modalDialog.alertType("您未设置过权限", "", "info", false);
                    return;
                }
                $scope.loadingPromise = trsHttpService.httpServer("/wcm/mlfcenter.do", params, "post").then(function(data) {
                    modalDialog.alertType("保存权限成功", "", "success", false,
                        function() {
                            //selecetedChanls = {};
                            //保存成功后取消选择开始
                            //cancelSelectedNode();
                            //保存成功后取消选择结束
                            //保存成功后关闭原子权限开始
                            //delete $scope.rightClassify;
                            //保存成功后关闭原子权限结束
                        });
                });
            };
            //保存权限结束
            //获取树开始
            function getTreeNodes(roleId, callback) {
                getRootNode().then(function(data) {
                    // data.HASCHILDREN = "false";
                    $scope.channelTree = [data];
                    $scope.expandedNodes.push($scope.channelTree[0]);
                }).then(function() {
                    if (angular.isFunction(callback)) callback();
                });
            }
            //获取树结束
            /**
             * [getRootNode description] 获取根节点
             * @return {[type]} [description]
             */
            function getRootNode() {
                var deffer = $q.defer();
                var params = {
                    serviceid: "mlf_extrole",
                    methodname: "queryResourceMediaProduct",
                    RoleId: $scope.roleData.ROLEID,
                    modalname: '运营中心',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }
            //获取权限列表开始
            function queryRightClassify(classify) {
                var params = {
                    "serviceid": "mlf_extrole",
                    "methodname": "queryRightClassify",
                    "Classify": classify
                };
                $scope.loadingPromise = trsHttpService.httpServer("/wcm/mlfcenter.do", params, "get").then(
                    function(data) {
                        if ($scope.authorSelectedNode !== undefined) {
                            $scope.rightClassify = data;
                            //初始化全选按钮开始
                            $scope.initSelectAll();
                            //初始化全选按钮结束
                        }
                    }
                );
            }
            //获取权限列表结束
            //初始化全选按钮方法开始
            $scope.initSelectAll = function() {
                $scope.rightClassify.selectAll = true;
                for (var i = 0; i < $scope.rightClassify.CHILDREN.length; i++) {
                    $scope.rightClassify.CHILDREN[i].selectAll = true;
                    for (var j = 0; j < $scope.rightClassify.CHILDREN[i].CHILDREN.length; j++) {
                        if ($scope.authorSelectedNode.RIGHTVALUE.length === 0 || $scope.authorSelectedNode.RIGHTVALUE[$scope.rightClassify.CHILDREN[i].CHILDREN[j].RIGHTINDEX - 1] == "0") {
                            $scope.rightClassify.CHILDREN[i].selectAll = false;
                        }
                    }
                    if ($scope.rightClassify.CHILDREN[i].selectAll === false) {
                        $scope.rightClassify.selectAll = false;
                    }
                }
            };
            //初始化全选按钮方法结束
        // 初始化全选按钮方法结束
        // 删除模板结束
            /**
             * [initData 初始化数据]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.hideLeft = true; // 隐藏掉左侧树；
                // 获取左侧树开始
                getTreeNodes($scope.roleData.ROLEID, function(data) {
                    $scope.cTshowSelected($scope.channelTree[0]);
                    $scope.perSelectedNode = $scope.channelTree[0];
                });
                // 获取左侧树结束
                // 获取从产品列表得到的产品数据开始
                getProductListData();
                // 获取从产品列表得到的产品数据结束
                if ($scope.roleData === undefined) {
                    modalDialog.alertType('请先选择角色', '', 'info', false);
                    $state.go('manageconfig.rolemanage');
                }
                // 监控角色切换开始
                $scope.$on('roleData', function(event, data) {
                    $scope.roleData = data;
                    getTreeNodes($scope.roleData.ROLEID, function(data) {
                        $scope.cTshowSelected($scope.channelTree[0]);
                        $scope.perSelectedNode = $scope.channelTree[0];
                    });
                    delete $scope.rightClassify;
                });
                // 监控角色切换结束
                // 模板名称字数限制开始
                $scope.tempNameNum = 6;
                // 模板名称字数限制结束
            }
            function getProductListData() {
                $scope.moduleName = '运营中心';
                $scope.classify = 'operationcenter';
            }
            //获取从产品列表得到产品数据结束
            //取消选择树节点开始
            function cancelSelectedNode() {
                delete $scope.perSelectedNode;
            }
            //取消选择树节点结束

            /**
             * 描述：保存为模板
             * 作者：媒立方
             * 日期：2017-10-31
             */
            $scope.SavePermissions = function() {
                var savePermissions = $modal.open({
                    templateUrl: "./manageConfig/roleManageMent/permissionAssignment/service/SavePerModule/SavePerModule.html",
                    scope: $scope,
                    windowClass: 'manageSavePerTemp',
                    backdrop: false,
                    controller: "SavePerModuleController"
                });
            };
            /**
             * [selectTemplateFn description] 选择模板
             * @return {[type]} [description]
             */
            $scope.selectTemplateFn = function() {
                $timeout(function() {
                    if (!angular.isArray($scope.selectTemplate.NEWVALUE) && $scope.selectTemplate.NEWVALUE !== undefined) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.selectTemplate.NEWVALUE.split("");
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf("1") > -1 ? true : false;
                        var tempObj = {
                            "ID": parseInt($scope.authorSelectedNode.RIGHTID),
                            "OPRTYPE": 203,
                            "OPRID": parseInt($scope.roleData.ROLEID),
                            "OBJTYPE": parseInt($scope.authorSelectedNode.OBJTYPE),
                            "OBJID": parseInt($scope.authorSelectedNode.OBJID),
                            "NEWVALUE": $scope.authorSelectedNode.RIGHTVALUE
                        };
                        selecetedChanls[$scope.authorSelectedNode.OBJID] = tempObj;
                        //全选按钮初始化开始
                        $scope.initSelectAll();
                        //全选按钮初始化结束
                    }
                });
            };
        }
    ]);